import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { Component } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';
import { StateService, Transition } from '@uirouter/core';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import {
    MonUIRouterTransitionService,
} from '@monsido/services/ui-router-transition-service/ui-router-transition-service';
import { LanguageMatchSummaryComponent } from './summary/language-match-summary.component';
import { LanguageMatchPagesComponent } from './pages/language-match-pages.component';

@Component({
    selector: 'base-qa-language-match',
    template: `<ui-view name="content"></ui-view>`,
    standalone: true,
    imports: [UIRouterModule],
})
class BaseQALanguageMatchComponent {}

export const QA_LANGUAGE_MATCH_STATES: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.domain.qa.languageMatch',
        url: '/language-match',
        abstract: true,
        views: {
            'content@base.customer.domain.qa': {
                component: BaseQALanguageMatchComponent,
            },
        },
        redirectTo: 'base.customer.domain.qa.languageMatch.summary',
        // No shellPath here: abstract parents are not navigation targets.
        // The prefix is owned by the summary leaf below (as a shellAlias).
        data: {
            sidebar: 'quality',
        },
        resolve: [{
            token: 'domainHasLanguageMatchFeature',
            deps: [
                SessionService,
                StateService,
                ActiveFeatureService,
                MonUIRouterTransitionService,
                Transition,
            ],
            resolveFn: async (
                ng2SessionService: SessionService,
                $state: StateService,
                ng2ActiveFeatureService: ActiveFeatureService,
                ng2MonUIRouterTransitionService: MonUIRouterTransitionService,
                transition: Transition,
            ) => {
                if (
                    !ng2ActiveFeatureService.isFeatureActivePure('language_match')
                ) {
                    setTimeout(function () {
                        ng2MonUIRouterTransitionService.onTransitionFinished(
                            () => {
                                $state.go('base.customer.domain.qa.summary', transition.params());
                            },
                        );
                    });
                    return Promise.resolve(false);
                } else {
                    return Promise.resolve(true);
                }
            },
        }],
    },
    {
        name: 'base.customer.domain.qa.languageMatch.summary',
        url: '/summary',
        views: {
            'content@base.customer.domain.qa.languageMatch': {
                component: LanguageMatchSummaryComponent,
            },
        },
        data: {
            title: 'Acquia Web Governance - Language Validation Summary',
            /** Shell-facing path for CC breadcrumb/menu sync (see event-bus-bridge.init.ts) */
            shellPath: '/domains/:domainId/quality/language-match/summary',
            // Incoming alias: breadcrumb clicks on 'Language Match' use the group prefix.
            shellAliases: ['/domains/:domainId/quality/language-match'],
        },
    },
    {
        name: 'base.customer.domain.qa.languageMatch.pages',
        url: '/pages',
        views: {
            'content@base.customer.domain.qa.languageMatch': {
                component: LanguageMatchPagesComponent,
            },
        },
        data: {
            title: 'Acquia Web Governance - Pages with language issues',
            shellPath: '/domains/:domainId/quality/language-match/pages',
        },
    },
];
